import { useTranslation } from 'react-i18next';
import { InfoSectionTitle } from '@/components/Approval/@components/InfoSection';
import { StorageMaterialOrderSnapshot } from '@/components/Approval/@components/StorageMaterialOrder';
import { parseStorageMaterialOrderContent } from '@/utils/approval/storageMaterialOrder';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 125 GERP 저장부자재 발주 — 저장 본문 그대로(레거시 문서 포함). GERP 재조회 안 함 */
const StorageMaterialOrderSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const content = parseStorageMaterialOrderContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <InfoSectionTitle sx={{ mb: 1 }}>{t('정산 내역')}</InfoSectionTitle>
      <StorageMaterialOrderSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default StorageMaterialOrderSlot;
